import styled from "styled-components";

export const ScheduleReserveDetailContainerStyled = styled.div`
  padding: 20px 20px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .music_hall_and_practice_detail_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .header_layout {
      margin-bottom: 42px;
    }
    .musicpractice_layout {
      margin-bottom: 26px;
    }
    .upcoming_event_layout {
      margin-bottom: 11px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S22};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_BOLD};
    }
    .upcoming_layout {
      margin-bottom: 20px;
    }
    .address_info_layout {
      margin-bottom: 20px;
    }
    /* ปุ่มห้องซ้อม ชื่อยาวกว่าปุ่มอื่น จึงกว้างกว่า */
    .practice_room_btn_layout {
      margin: auto;
      margin-bottom: 30px;
      max-width: 420px;
    }
    .interesting_layout {
      margin: auto;
      margin-bottom: 30px;
      max-width: 310px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 46px 20px;
    .breadcrumb_layout {
      display: none;
    }
    .music_hall_and_practice_detail_container {
      /* ชื่อปุ่มยาว ให้กว้างเต็มจอ (เหลือขอบ padding ของหน้า) จะได้ไม่ตกบรรทัด */
      .practice_room_btn_layout {
        max-width: 100%;
      }
      .interesting_layout {
        max-width: 294px;
      }
    }
  }
`;
